(function () {

  function initAnchorNav(root) {

    if (!root || root.dataset.ptsNavInit === 'true') return;

    root.dataset.ptsNavInit = 'true';



    var links = Array.prototype.slice.call(root.querySelectorAll('[data-pts-nav-link]'));

    var scroller = root.querySelector('[data-pts-nav-scroll]');

    var arrowPrev = root.querySelector('[data-pts-nav-arrow-prev]');

    var arrowNext = root.querySelector('[data-pts-nav-arrow-next]');

    var bar = root.querySelector('.pts-anchor-nav__bar');

    var placeholder = root.querySelector('[data-pts-nav-placeholder]');



    function syncNavHeight() {

      if (!bar) return;

      document.documentElement.style.setProperty('--pts-nav-height', bar.offsetHeight + 'px');

    }



    function findTarget(id) {

      return document.getElementById(id) || document.querySelector('[data-pts-anchor="' + id + '"]');

    }



    function scrollToTarget(el) {

      syncNavHeight();

      var navH = bar ? bar.offsetHeight : 0;

      var top = el.getBoundingClientRect().top + window.scrollY - navH;

      var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      window.scrollTo({ top: Math.max(0, top), behavior: behavior });

    }



    function updateStuck() {

      if (!bar || !placeholder) return;

      if (!root.classList.contains('is-stuck')) {

        if (root.getBoundingClientRect().top <= 0) {

          placeholder.style.height = bar.offsetHeight + 'px';

          root.classList.add('is-stuck');

        }

      } else if (placeholder.getBoundingClientRect().top > 0) {

        root.classList.remove('is-stuck');

        placeholder.style.height = '0px';

      }

    }



    function setActive(target) {

      links.forEach(function (link) {

        link.classList.toggle('is-active', link.getAttribute('data-pts-nav-link') === target);

      });

    }



    window.addEventListener('scroll', updateStuck, { passive: true });

    window.addEventListener('resize', function () {

      syncNavHeight();

      updateStuck();

    });



    syncNavHeight();

    updateStuck();



    links.forEach(function (link) {

      link.addEventListener('click', function (e) {

        var id = link.getAttribute('data-pts-nav-link');

        var el = findTarget(id);

        if (!el) return;

        e.preventDefault();

        scrollToTarget(el);

        setActive(id);

      });

      link.addEventListener('focus', function () {

        if (!scroller) return;

        var r = link.getBoundingClientRect();

        var sr = scroller.getBoundingClientRect();

        if (r.left < sr.left || r.right > sr.right) {

          scroller.scrollBy({ left: r.left - sr.left - 16, behavior: 'auto' });

        }

      });

    });



    if (arrowPrev && scroller) {

      arrowPrev.addEventListener('click', function () {

        var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        scroller.scrollBy({ left: -160, behavior: behavior });

      });

    }

    if (arrowNext && scroller) {

      arrowNext.addEventListener('click', function () {

        var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        scroller.scrollBy({ left: 160, behavior: behavior });

      });

    }



    var sections = links

      .map(function (l) { return findTarget(l.getAttribute('data-pts-nav-link')); })

      .filter(Boolean);



    if ('IntersectionObserver' in window && sections.length) {

      var observer = new IntersectionObserver(

        function (entries) {

          entries.forEach(function (entry) {

            if (!entry.isIntersecting) return;

            var id = entry.target.id || entry.target.getAttribute('data-pts-anchor');

            if (!id) return;

            setActive(id);

            var active = root.querySelector('[data-pts-nav-link="' + id + '"]');

            if (active && scroller) {

              var r = active.getBoundingClientRect();

              var sr = scroller.getBoundingClientRect();

              if (r.left < sr.left || r.right > sr.right) {

                var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

                scroller.scrollBy({ left: r.left - sr.left - 16, behavior: behavior });

              }

            }

          });

        },

        { rootMargin: '-30% 0px -60% 0px' }

      );

      sections.forEach(function (s) { observer.observe(s); });

    }

  }



  function initMobileScale() {

    var mobileQuery = window.matchMedia('(max-width: 767px)');

    var GUTTER = 28;

    var scaleConfigs = [

      { outer: '.pts-offers__mobile-scale-outer', inner: '.pts-offers__mobile-scale', designW: 365, fixedH: 1005 },

      { outer: '.pts-offers__mobile-tail-scale-outer', inner: '.pts-offers__mobile-tail-scale', designW: 365 },

      { outer: '.pts-spin-aura__mobile-scale-outer', inner: '.pts-spin-aura__mobile-scale', designW: 365 }

    ];



    function updateOffersLowerBgMobile() {

      document.querySelectorAll('section.pts-offers').forEach(function (section) {

        if (!mobileQuery.matches) {

          section.style.removeProperty('--pts-offers-lower-bg-top-mobile');

          return;

        }

        var wave = section.querySelector('.pts-offers__m-spin-zone .pts-spin-aura__wave-mask--mobile');

        if (!wave) return;

        var sectionRect = section.getBoundingClientRect();

        var waveRect = wave.getBoundingClientRect();

        var lowerBgTop = waveRect.bottom - sectionRect.top - 1;

        section.style.setProperty(

          '--pts-offers-lower-bg-top-mobile',

          Math.max(0, lowerBgTop) + 'px'

        );

      });

    }



    function applyScale() {

      scaleConfigs.forEach(function (cfg) {

        document.querySelectorAll(cfg.outer).forEach(function (outer) {

          var inner = outer.querySelector(cfg.inner);

          if (!inner) return;



          if (mobileQuery.matches) {

            var scale = (window.innerWidth - GUTTER) / cfg.designW;

            inner.style.position = 'absolute';
            inner.style.left = '50%';
            inner.style.top = '0';
            inner.style.transform = 'translateX(-50%) scale(' + scale + ')';
            inner.style.transformOrigin = 'top center';

            var innerH = cfg.fixedH != null ? cfg.fixedH : Math.max(inner.offsetHeight, inner.scrollHeight);

            outer.style.height = innerH * scale + 'px';

          } else {

            inner.style.position = '';
            inner.style.left = '';
            inner.style.top = '';
            inner.style.transform = '';
            inner.style.transformOrigin = '';
            outer.style.height = '';

          }

        });

      });



      document.querySelectorAll('.pts-offers .pts-offers__title').forEach(function (title) {

        if (!mobileQuery.matches) {

          title.style.fontSize = '';

          title.style.lineHeight = '';

          title.style.marginBottom = '';

          return;

        }

        var scale = (window.innerWidth - GUTTER) / 365;

        title.style.fontSize = 28 * scale + 'px';

        title.style.lineHeight = 28 * scale + 'px';

        title.style.marginBottom = 16 * scale + 'px';

      });



      updateOffersLowerBgMobile();

      window.requestAnimationFrame(updateOffersLowerBgMobile);

    }



    applyScale();



    if (document.documentElement.dataset.ptsMobileScaleInit === 'true') {

      return;

    }

    document.documentElement.dataset.ptsMobileScaleInit = 'true';



    window.addEventListener('resize', applyScale, { passive: true });

    window.addEventListener('orientationchange', applyScale, { passive: true });

    if (mobileQuery.addEventListener) {

      mobileQuery.addEventListener('change', applyScale);

    }



    document.querySelectorAll('.pts-mobile-scale-outer img').forEach(function (img) {

      if (img.complete) return;

      img.addEventListener('load', applyScale, { once: true });

    });

    document.querySelectorAll('.pts-offers__m-spin-zone img').forEach(function (img) {

      if (img.complete) return;

      img.addEventListener('load', applyScale, { once: true });

    });

  }



  function boot() {

    document.querySelectorAll('[data-pts-anchor-nav]').forEach(initAnchorNav);

    initMobileScale();

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', boot);

  } else {

    boot();

  }



  document.addEventListener('shopify:section:load', boot);

  document.addEventListener('shopify:section:reorder', boot);

})();


